// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".settings-editor-wrapper{padding:5px}.settings-editor-wrapper .settings-editor{width:400px;padding:10px;border-radius:4px;background-color:rgba(var(--color-gray-200), 0.9);backdrop-filter:blur(16px)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
